// Import createSlice from @reduxjs/toolkit
import { createSlice } from "@reduxjs/toolkit";

// Define initial state
const initialState = {
  printrtTyp: [],
  companyInfo: {},
  isDrawerAlways: false,
  decimalCount: 3,
  primaryCurrency: "",
  subCurrency: "",
  isADDon: false,
  allKot: false,
  KotEnabled: false,
  isAccountsShow: false,
  taxUtilitiesListData: [],
  userDetail: { user: "", prev: [] },
  moduleHeading: "",
  QrShowPrint: false,
  isAddOnAlways: false,
  IsRestaurant: false,
  salesBillDeclaration: "",
  orderFormDeclaration: "",
  billWiseTax: 0,
  isDiscount: "NO",
  isPaidMethod: "NO",
  isInvoice: false,
  isFree: false,
};

// Create a slice
const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    // Action to set the array of printrtTyp
    setPrintrtTyp: (state, action) => {
      state.printrtTyp = action.payload;
    },

    // Action to set the companyInfo object
    setCompanyInfo: (state, action) => {
      state.companyInfo = action.payload;
    },
    // Action to set the drawer always on object
    setIsDrawerAlways: (state, action) => {
      state.isDrawerAlways = action.payload;
    },
    // Action to set the decimal value
    setDecimalCount: (state, action) => {
      state.decimalCount = action.payload;
    },
    // Action to set the primary currency value
    setPrimaryCurrency: (state, action) => {
      state.primaryCurrency = action.payload;
    },
    // Action to set the sub currency value
    setSubCurrency: (state, action) => {
      state.subCurrency = action.payload;
    },
    setCommonState(state, action) {
      Object.assign(state, action.payload);
    },
    setUserDetail(state, action) {
      state.userDetail = action.payload;
    },
    setModuleHeading(state, action) {
      state.moduleHeading = action.payload;
    },
    setQrShowPrint(state, action) {
      state.QrShowPrint = action.payload;
    },
    setSalesBillDeclaration(state, action) {
      state.salesBillDeclaration = action.payload;
    },
    setOrderFormDeclarationn(state, action) {
      state.orderFormDeclaration = action.payload;
    },
    setIsFree(state, action) {
      state.isFree = action.payload;
    },
  },
});

// Export the actions and reducer
export const {
  setPrintrtTyp,
  setCompanyInfo,
  setIsDrawerAlways,
  setDecimalCount,
  setPrimaryCurrency,
  setSubCurrency,
  setCommonState,
  setUserDetail,
  setModuleHeading,
  setQrShowPrint,
  setSalesBillDeclaration,
  setOrderFormDeclarationn,
  setIsFree,
} = commonSlice.actions;
export default commonSlice.reducer;
